// extracted by mini-css-extract-plugin
export var container = "agri-module--container--p2jrT";
export var figName = "agri-module--figName--ars6E";
export var float = "agri-module--float--t4oNr";